/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import React from 'react'
import { Section, showModal, getState, parseHtml, fmt } from '../twd'
import { sectionCss, tableCss } from './style'
import { useBondDetail } from './use-bond-detail'

const state = getState('bond_detail.mbs_speed', {
    show: true
})

export default () => {
    const [showSection, setShowSection_] = React.useState(state.value.show)
    const setShowSection = React.useCallback((m) => {
        state.set({show:m})
        setShowSection_(m)
    }, [])


    const {offer} = useBondDetail()
    let hasMbs = !offer.errorText
        && offer.mbsSpeedLevel && offer.mbsSpeedLevel.length > 0
        && offer.speedHistory && offer.speedHistory.length > 0

    if (!hasMbs) return null

    let speed = offer.speedHistory.map(parseHtml)

    return <React.Fragment>
    <div className="xs-hide vertical-offset-sm"></div>
    <div data-name='bond-detail-mbs-speed'
        className="container vertical-offset-sm"
        css={sectionCss}>

        <div className="row vertical-offset-sm"></div>

        <div className="row"><div className="col-xs-12">
            <Section
                title="MBS information"
                show={showSection}
                setShow={setShowSection}
                cls="small-header"
                arrowSize="large"
            >
            <table className="table" css={tableCss}>
            <thead>
            <tr>
                <th>MBS speed information</th>
                <th className="text-right">
                    <button
                    className="link-button"
                    onClick={(e) => {
                        showModal({
                            view: 'mbs-speed',
                            list: offer.mbsSpeedLevel,
                            from: 'bond-detail',
                            source: e.target,
                        })
                    }}>
                    View chart</button>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>1 month actual</td>
                <td>{speed[0] || fmt.empty()}</td>
            </tr>
            <tr>
                <td>3 month avg.</td>
                <td>{speed[1] || fmt.empty()}</td>
            </tr>
            <tr>
                <td>6 month avg.</td>
                <td>{speed[2] || fmt.empty()}</td>
            </tr>
            <tr>
                <td>12 month avg.</td>
                <td>{speed[3] || fmt.empty()}</td>
            </tr>
            <tr>
                <td>Lifetime avg.</td>
                <td>{speed[4] || fmt.empty()}</td>
            </tr>
            </tbody>
            </table>
            </Section>
        </div></div>
    </div>

    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/bond-detail/mbs-speed.js